import React, {Component, Fragment, PureComponent} from 'react';
import {ListView,WhiteSpace} from 'antd-mobile';
import PublicHeader from './../../components/header/index';
import {connect} from 'react-redux';
import './index.scss';
import history from './../../utils/history';

import {formatDate} from '../../utils/common';

import {getUserChargeList} from './store/actionCreators';

const NUM_ROWS = 10;
let pageIndex = 0;

function genData(pIndex = 0) {
    const dataBlob = {};
    for (let i = 0; i < NUM_ROWS; i++) {
        const ii = (pIndex * NUM_ROWS) + i;
        dataBlob[`${ii}`] = `row - ${ii}`;
    }
    return dataBlob;
}

class MyCharge extends PureComponent {

    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            dataSource,
            isLoading: true,
        }
    }

    componentDidMount() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }

        this.props.getUserChargeList(pageIndex, oauthInfo.id);

        setTimeout(() => {
            this.rData = genData();
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rData),
                isLoading: false,
            });
        }, 600);
    }

    onEndReached = (event) => {
        // load new data
        // hasMore: from backend data, indicates whether it is the last page, here is false
        const {orderList} = this.props;
        const {data = [], total} = orderList;

        if (data.length >= total) {
            this.setState({hasMore: false});
        } else {
            setTimeout(() => {
                this.setState({hasMore: false}, () => {
                    this.currentPage = ++this.currentPage;
                    this.props.getUserChargeList(++pageIndex).then(() => {
                        this.setState({hasMore: true});
                    });
                });
            }, 200);
        }
    }

    render() {
        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 8,
                    borderTop: '1px solid #ECECED',
                    borderBottom: '1px solid #ECECED',
                }}
            />
        );

        const {userChargeList = []} = this.props;
        const {data = [{}]} = userChargeList;
        let {dataSource} = this.state;

        const row = (rowData, sectionID, rowID) => {
            if (JSON.stringify(rowData) == "{}") {
                return (<div>
                    <div className="user-recharge" style={{textAlign: "center", padding: "15px", color: "#888"}}>
                        暂无充值信息
                    </div>
                </div>);
            }
            const obj = rowData;
            return (
                <div key={rowID} style={{padding: '0 15px'}} data-id={obj.id}>
                    <div className="user-recharge">
                        <div className="time">{obj.methodDesc}<span>{formatDate(obj.createTime)} </span></div>
                        <ul className="money">
                            <li>充值金额：<span className="text">￥{obj.rechargeAmount}</span>
                            </li>
                        </ul>
                        <div className="time" style={{color:"#DE4D4D"}}>赠送 ￥{obj.giftAmount}<span style={{color:"#FD9D24"}}>余额：￥{obj.balance} </span></div>

                    </div>
                </div>
            );
        };

        return (
            <Fragment>
                <PublicHeader title="充值记录"/>
                <WhiteSpace size="sm" style={{background: "#eee"}}/>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource.cloneWithRows(data)}
                    renderFooter={() => (<div style={{padding: 30, textAlign: 'center'}}>
                        {this.state.isLoading ? '加载中...' : '已经到底啦～'}
                    </div>)}
                    renderRow={(rowData, id1, i) => row(rowData, i)}
                    renderSeparator={separator}
                    className="recharge-list"
                    pageSize={4}
                    useBodyScroll
                    onScroll={() => {
                        console.log('scroll');
                    }}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (data) => {
    return {
        userChargeList: data.userChargeList.userChargeList
    }
};

const mapDispatchToProps = (dispatch) => ({
    getUserChargeList: (pageIndex, userId) => dispatch(getUserChargeList({userId: userId, pageNo: pageIndex, size: 20}))
});


export default connect(mapStateToProps, mapDispatchToProps)(MyCharge);
